module.exports = __webpack_public_path__ + "img/mammals.924a8f32.png";